import { render, staticRenderFns } from "./sub-menu.vue?vue&type=template&id=5844b6a9&scoped=true&"
import script from "./sub-menu.vue?vue&type=script&lang=js&"
export * from "./sub-menu.vue?vue&type=script&lang=js&"
import style0 from "./sub-menu.vue?vue&type=style&index=0&id=5844b6a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5844b6a9",
  null
  
)

export default component.exports